import React from 'react'
import AdminLayout from '../../components/layout/AdminLayout'
import PurchaseBox from '../../components/manager/PurchaseBox'
import AdminContentLayout from '../../components/layout/AdminContentLayout'
import CurriculumLayout from '../../components/layout/CurriculumLayout'
import ParentsDashboardBox from '../../components/parents/ParentsDashboardBox'

const DashboardParents = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <ParentsDashboardBox />
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default DashboardParents
